/** Conteneur centré — même largeur que Flux de marché / Leaders */
export const INV_MARKET_WRAP_CSS = `
.inv-market-wrap{
  max-width:min(1920px,100%);
  margin:0 auto;
  padding:26px 32px 40px;
  width:100%;
  box-sizing:border-box;
}
@media(max-width:1200px){
  .inv-market-wrap{padding:22px 18px 32px;}
}
@media(max-width:768px){
  .inv-market-wrap{padding:16px 12px 24px;}
}
`;

/** Styles partagés Leaders / Flux de marché — hero KPI, toolbar, espacements */
export const MARKET_PAGE_LAYOUT_CSS = `
.td-headerContent{
  display:flex;justify-content:space-between;align-items:flex-start;gap:20px;
  margin:0 clamp(4px, 1vw, 12px) 4px;
  padding:24px 22px 20px;
  background:var(--paper);
  border:1px solid var(--line);
  border-radius:var(--radius);
  box-shadow:var(--shadow2);
}
.td-toolbar{
  display:flex;justify-content:flex-start;align-items:center;
  gap:12px 16px;
  flex-wrap:wrap;
  margin:16px 6px 22px;
  padding:0;
}
.td-toolbarHint{
  font-size:12px;font-weight:800;color:var(--muted);
  margin:0;line-height:1.4;
}
@media(max-width:1000px){
  .td-headerContent{flex-direction:column;gap:16px;padding:18px 16px;margin:0 4px 4px;}
  .td-toolbar{margin:14px 4px 18px;gap:10px 12px;}
}
@media(max-width:640px){
  .td-headerContent{padding:14px 14px 12px;border-radius:14px;}
  .td-toolbar{flex-direction:column;align-items:stretch;margin:12px 2px 16px;}
  .td-toolbar .td-select{width:100%;max-width:100%;}
}
.td-viewIconBtn.active,
.td-viewIconBtn[aria-pressed="true"]{
  background:linear-gradient(#e8e0d0,#e0d8c8);
  border-color:rgba(181,154,91,.5);
}
`;
